var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartbeat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 19,
  viewBox: "0 0 22 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 6.23005C1.14308 2.06992 6.19248 -1.74867 11.0003 3.69612C17.3282 -3.47488 24.0777 5.41926 19.4914 10.004L11.0003 17.7689L4.96628 12.2518",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.53687 9.30713H5.61389L7.1524 6.2301L9.46017 11.6149L11.7679 8.53787H14.0757",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgHeartbeat;